import { render, staticRenderFns } from "./CardModalDetailsTypeText.vue?vue&type=template&id=33d40f1c"
import script from "./CardModalDetailsTypeText.vue?vue&type=script&lang=js"
export * from "./CardModalDetailsTypeText.vue?vue&type=script&lang=js"
import style0 from "./CardModalDetailsTypeText.vue?vue&type=style&index=0&id=33d40f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports